import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PressContent from './PressContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <PressContent history={history} />
  </Mobile>
);

export default MobileResponsive;
